import { Component, OnInit, Input } from '@angular/core';
import { IPermission } from '../../../interfaces/graph-types';
import { Observable, Subscription } from 'rxjs';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { ModalInviteTeamMemberComponent } from '../../modals/invite-team-member/modal-invite-team-member.component';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';

@Component({
  selector: 'team-members',
  template: require('./team-members.component.pug'),
  styles: [require('./team-members.component.css').toString()],
})
export class TeamMembersComponent implements OnInit {
  @Input()
  orgId: string = null;

  @Input()
  accountId: string = null;

  permissions$: Observable<IPermission[]>;
  bsModalRef: BsModalRef;
  sub: Subscription;

  isLoading = false;

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private orgService: OrganizationService,
    private accountService: AccountService,
    private watchAccountService: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    if (this.orgId) {
      this.loadPermissions();
    } else {
      this.isLoading = true;
      this.sub = this.accountService
        .getOrganizationId(this.watchAccountService.accountId().getValue())
        .subscribe(account => {
          this.isLoading = false;
          this.orgId = account.organization.id;
          this.loadPermissions();
        });
    }
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  loadPermissions() {
    this.permissions$ = this.orgService.permissions(this.orgId);
  }

  // -------------------------------------------------------------------
  openModalTeamMemberInvite() {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      orgId: this.orgId,
    };
    this.bsModalRef = this.modalService.show(
      ModalInviteTeamMemberComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  // -------------------------------------------------------------------
  delete(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.orgService.removeTeamMember(
      this.orgId,
      data.id,
      result => {
        this.loadPermissions();
        //data.hide = true;
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  changeAdmin(
    perm: IPermission,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.orgService.setPermissionAdmin(
      this.orgId,
      perm.id,
      !perm.admin,
      () => {
        perm;
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
